import type { Content, ContentTable } from 'pdfmake/interfaces';

import { createSubHeading } from '@/utils/pdf/headings';
import { optionalTableSection } from '@/utils/pdf/tableSection';

/**
 * Build a rating section for the risk PDF export.
 *
 * Ratings reach the export by two different routes. Under the default scoring
 * model they are `risk_assessment_result` rows and render as the assessment
 * table. Under an aggregation model the score is computed into `risk_score`
 * and no assessment row exists (CUS-327) — the aggregated table carries the
 * current rating instead. Prefer the assessment table when it has rows, so
 * orgs that switched models keep their historical ratings visible.
 */
export const ratingSection = (
  heading: string,
  assessmentTable: ContentTable,
  aggregatedTable: ContentTable | null
): Content[] => {
  const assessmentSection = optionalTableSection(heading, assessmentTable);
  if (assessmentSection.length > 0) {
    return assessmentSection;
  }

  return aggregatedTable ? [createSubHeading(heading), aggregatedTable] : [];
};
